const counts = new Map<string, number>();
const listeners = new Set<() => void>();
export const subscribeHeaderSlots = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
export const hasThemeHeaderSlot = (id: string) => (counts.get(id) ?? 0) > 0;
export const serverHasThemeHeaderSlot = () => false;

/** Reference counted because themes can have separate desktop/mobile headers. */
export function registerThemeHeaderSlot(id: string) {
  counts.set(id, (counts.get(id) ?? 0) + 1);
  for (const listener of listeners) listener();
  return () => {
    const next = (counts.get(id) ?? 1) - 1;
    if (next > 0) counts.set(id, next);
    else counts.delete(id);
    for (const listener of listeners) listener();
  };
}
